import type {AxiosError} from "axios";

import {DEVICE_FAILURE_ERROR_CODES, type FailureDomain} from "./failure-domains";
import {normalizeHttpPathTag} from "./http-context";

export function resolveAxiosDeviceFailureOverride(
  error: AxiosError,
): {errorCode: string; failureDomain: FailureDomain; level?: "warning" | "error"} | null {
  const path = normalizeHttpPathTag(error.config?.url);
  const operation = error.config?.meta?.operation;
  const status = error.response?.status;
  const isNetwork = !error.response && Boolean(error.request);

  if ((path === "broadcasting/config" || path.startsWith("broadcasting/")) && isNetwork) {
    return {
      errorCode: DEVICE_FAILURE_ERROR_CODES.REALTIME_CONNECTION_FAILED,
      failureDomain: "realtime",
      level: "warning",
    };
  }

  if (path.startsWith("broadcasting/") && typeof status === "number" && status >= 500) {
    return {
      errorCode: DEVICE_FAILURE_ERROR_CODES.BROADCASTING_AUTH_FAILED,
      failureDomain: "realtime",
      level: "warning",
    };
  }

  if (path === "push-subscriptions") {
    if (isNetwork || (typeof status === "number" && status >= 500)) {
      return {
        errorCode: DEVICE_FAILURE_ERROR_CODES.PUSH_SUBSCRIPTION_FAILED,
        failureDomain: "notification",
        level: "warning",
      };
    }
  }

  if (
    error.config?.meta?.feature === "shifts" &&
    (isNetwork || (typeof status === "number" && status >= 500))
  ) {
    if (operation === "shift_start") {
      return {
        errorCode: DEVICE_FAILURE_ERROR_CODES.SHIFT_START_FAILED,
        failureDomain: "network",
        level: "warning",
      };
    }
    if (operation === "shift_end") {
      return {
        errorCode: DEVICE_FAILURE_ERROR_CODES.SHIFT_END_FAILED,
        failureDomain: "network",
        level: "warning",
      };
    }
    if (operation === "break_action") {
      return {
        errorCode: DEVICE_FAILURE_ERROR_CODES.BREAK_ACTION_FAILED,
        failureDomain: "network",
        level: "warning",
      };
    }
  }

  return null;
}
